import styles from './SuccessContent.module.scss';
import { Button, Icon, Text } from 'components';

type Props = {
  email: string;
  onClose(): void;
};

export const SuccessContent = ({ email, onClose }: Props) => {
  return (
    <div>
      <div className={styles.newUserCreatedMessage}>
        <Icon name="Tick" />
        <Text className={styles.successTitle} type="body-big">
          New user successfully created
        </Text>
        <div className={styles.descriptionText}>
          <Text type="body2" className={styles.helpMessage}>
            The link to proceed with registration process is sent to
            <Text type="body2" className={styles.email}>
              {email}
            </Text>
          </Text>
        </div>
      </div>
      <div className={styles.buttonRow}>
        <Button onClick={onClose} className={styles.confirmButton}>
          Confirm
        </Button>
      </div>
    </div>
  );
};
